export default "__VITE_ASSET__DJhRU3_d__"